import store from '../state';
import { PersonaId } from '../personas/types';
import { ALL_PERSONAS, setActivePersona } from '../personas/registry';

export function setupUrlHashSync() {
  // 1. Initial Load: Read Hash for Persona
  const readHash = () => {
    const rawHash = window.location.hash.substring(1);
    if (!rawHash) return;
    
    const params = new URLSearchParams(rawHash);
    let personaId = (params.get('persona') || '') as PersonaId;
    
    // Support direct hash e.g. #stargazing or #photography
    if (!personaId && ALL_PERSONAS[rawHash as PersonaId]) {
      personaId = rawHash as PersonaId;
    }
    
    // If legacy product parameter is present without persona, strip it clean
    if (params.get('product') && !params.get('persona')) {
      const currentPersona = store.getState().activePersona || 'general';
      const cleanHash = `#persona=${currentPersona}`;
      window.history.replaceState(null, '', cleanHash);
      return;
    }

    if (personaId && ALL_PERSONAS[personaId]) {
      const currentState = store.getState();
      if (currentState.activePersona !== personaId) {
        setActivePersona(personaId);
      }
    }
  };

  window.addEventListener('hashchange', readHash);
  readHash();

  // 2. Write Persona Hash on State Changes
  store.subscribe((state) => {
    if (state.activePersona) {
      const newHash = `#persona=${state.activePersona}`;
      if (window.location.hash !== newHash) {
        window.history.replaceState(null, '', newHash);
      }
    }
  });
}
